// extracted by mini-css-extract-plugin
module.exports = {"content":"HomePage_content__1ZxO-","footer":"HomePage_footer__2PR2j"};